import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  open: boolean;
  itemToDelete: string;
  onSubmit: () => void;
  onClose: () => void;
}

const DeleteConfirmationDialog = ({
  open,
  itemToDelete,
  onSubmit,
  onClose,
}: Props) => {
  const handleSubmit = () => {
    onClose();
    onSubmit();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {`Delete ${itemToDelete}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {`${itemToDelete} will be deleted on confirmation.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='secondary' variant='contained'>
            Go Back
          </Button>
          <Button
            onClick={handleSubmit}
            color='error'
            variant='contained'
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteConfirmationDialog;
